var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgProductIcon = function SvgProductIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 17,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "M8 14.954c-.545 0-1.067-.22-2.109-.66C3.297 13.198 2 12.65 2 11.728V4.954m6 10c.545 0 1.067-.22 2.109-.66C12.703 13.198 14 12.65 14 11.728V4.954m-6 10V7.858m-4 .43 1.333.666m6-6L4.667 6.288m.884.46-1.948-.942C2.535 5.29 2 5.03 2 4.621s.535-.668 1.603-1.185l1.947-.942C6.753 1.912 7.353 1.62 8 1.62s1.247.29 2.45.873l1.947.942C13.465 3.953 14 4.212 14 4.62s-.535.668-1.603 1.185l-1.947.942c-1.203.582-1.803.873-2.45.873s-1.247-.29-2.45-.873"
  })));
};
export default SvgProductIcon;